/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_ExtraInputs */

const en_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Extras`)
};

const de_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif-Extras`)
};

const es_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras del plan`)
};

const fr_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras de forfait`)
};

const nl_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement-extras`)
};

const it_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra piano`)
};

const pt_br2_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras do plano`)
};

const pl_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodatki do planu`)
};

const hu_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csomag extrák`)
};

const ro_admin_dashboard_invoice_tags_extra = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra-uri Plan`)
};

/**
* | output |
* | --- |
* | "Plan Extras" |
*
* @param {Admin_Dashboard_Invoice_Tags_ExtraInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_extra = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_ExtraInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_ExtraInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_extra(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_extra(inputs)
	return ro_admin_dashboard_invoice_tags_extra(inputs)
});
export { admin_dashboard_invoice_tags_extra as "admin.dashboard.invoice_tags.extra" }